import SiafLiteApiRepository from "../../external/siafLiteApi";

class VinculoPessoaService {
  constructor() {
    this.urlBase = "/integracao/vinculo-pessoa";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  verificarVinculoPessoa(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }
}

export default VinculoPessoaService;
